import { apiFetch } from './http';

export interface PostDeployStatus {
  postDeployStatus: string;
  postDeploySteps: Record<string, string>;
  stackOutputs: Record<string, string>;
}

export interface PostDeployResult {
  status: string;
  step?: string;
  error?: string;
  results: Record<string, string>;
}


export async function getPostDeployStatus(tenantId: string): Promise<PostDeployStatus> {
  return apiFetch(`/ops/post-deploy-steps?tenantId=${tenantId}`);
}

export async function runPostDeploy(input: {
  tenantId: string;
  customerAccountId: string;
  version: string;
  stackName: string;
  contactEmail: string;
  contactName?: string;
  domain?: string;
  step?: string;
}): Promise<PostDeployResult> {
  return apiFetch('/ops/post-deploy-steps', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}
